/** @file Mesh form model: counts, binding, weighted bone count, and the bone a rigid mesh follows. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';

/** What the mesh form shows above its generated forms. */
export interface MeshStats {
  vertices: number;
  triangles: number;
  hull: number;
  skinned: boolean;
  bones: number;
  follows: string | null;
}

/** Null when `id` is not a mesh; `follows` is the bone of the first slot (skins by name) whose entry shows the mesh. */
export function meshStats(doc: Doc, id: Id): MeshStats | null {
  const att = doc.attachments[id];
  if (att?.type !== 'mesh') return null;
  const slot = entriesByName(doc.skins).flatMap(([, s]) => s.entries).find((e) => e.attachment === id)?.slot;
  const bone = slot === undefined ? undefined : doc.slots[slot]?.bone;
  const g = att.geometry;
  return {
    vertices: att.uvs.length / 2,
    triangles: att.triangles.length / 3,
    hull: att.hull,
    skinned: g.kind === 'skinned',
    bones: g.kind === 'skinned' ? Object.keys(g.bindPose).length : 0,
    follows: bone === undefined ? null : (doc.bones[bone]?.name ?? null),
  };
}
